import Vue from 'vue'
import { mapState } from 'vuex'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

// api
import PresentationApi from '@/api/presentation'
import Socket from '@/socket'

export default (QnAModerationCheckBox) => Vue.component('QnAModerationCheckBoxContainer', {
  props: {
    isOnSettingsMenu: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    async handleCheckBoxModeration() {
      try {
        const res = await PresentationApi.updatePresentationByPresentationId(this.presentation.id, {
          socketId: Socket.getSocketId(),
          isModerationMode: this.presentation.isModerationMode,
        })
        if (!this.presentation.moderationCode) {
          this.$store.state.presentation.moderationCode = res.body[1][0].moderationCode
        }
        this.$store.dispatch('updatePresentation', this.$store.state.presentation)
        utils.updateDataQuestionAnswer(this.$store.state.questions,
          this.$store.state.tabQnaQuestion)
        this._trackGAEvent()
      } catch (error) {
        this.$store.dispatch('setSyncPresentation', 3)

        if (error.status) {
          throw error
        }
      }
    },
    _trackGAEvent() {
      const settingsLocation = this.isOnSettingsMenu ? 'Settings' : 'Right column'
      const action = this.presentation.isModerationMode ? 'Checked' : 'Unchecked'
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        `Q&A Moderation > ${settingsLocation} > Q&A Moderation checkbox`,
        `${action}`,
      )
    },
  },
  render(createElement) {
    return createElement(QnAModerationCheckBox, {
      props: {
        handleCheckBoxModeration: this.handleCheckBoxModeration,
        isOnSettingsMenu: this.isOnSettingsMenu,
      },
    })
  },
})
